import cc from 'classcat';
import { useState } from 'react';
import { DrawLineIcon, ColorPicker } from '@i-ark/components';
import { breakpoints } from '@ui/css';
import { Tooltip } from '@ui/kit';
import { useMatchBreakpoint, CSSRefTransition } from '@utils/react';
import '@i-ark/models';
import '@utils/component-framework';
import '@tanstack/react-query';
import { selectOriginalComponentVersion } from '../../state/selectors/data.original-version.js';
import { iArkStore } from '../../state/store.js';
import { useShortcut } from '../hook.use-shortcut.js';
import { useUserOwnsEntry } from '../hook.user-owns-entry.js';
import { Button } from './atom.button.js';
import { lineToolButton, colorPickerWrapper, colorPickerCls, lineToolCls } from './tool.line.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const LineTool = () => {
  const isMobile = useMatchBreakpoint(breakpoints.mobile);
  const [isColorPickerOpen, setColorPickerOpen] = useState(false);
  const dispatch = iArkStore.useDispatch();
  const entryKey = iArkStore.useSelector(state => state.entryKey);
  const originalComponentVersion = iArkStore.useSelector(selectOriginalComponentVersion);
  const userOwnsEntry = useUserOwnsEntry(entryKey);
  const lineToolEnabled = iArkStore.useSelector(state => state.lineToolEnabled);
  const lineColor = iArkStore.useSelector(state => state.lineColor);
  const handleToggleLineTool = () => {
    dispatch(iArkStore.actions.toggleLineTool({
      enabled: !lineToolEnabled
    }));
  };
  const handleColorPickerOpen = () => {
    setColorPickerOpen(true);
  };
  const handleColorPickerClose = () => {
    setColorPickerOpen(false);
  };
  const handleChangeLineColor = nextColor => {
    dispatch(iArkStore.actions.changeLineColor(nextColor));
  };
  useShortcut("Escape", lineToolEnabled ? handleToggleLineTool : undefined);
  if (originalComponentVersion === 2 || !userOwnsEntry) {
    return null;
  }
  return /*#__PURE__*/jsxs("div", {
    className: cc([lineToolCls, {
      active: lineToolEnabled
    }]),
    children: [/*#__PURE__*/jsx(Button, {
      className: lineToolButton,
      activated: lineToolEnabled,
      tooltip: !lineToolEnabled ? "Tegn en streg" : undefined,
      onClick: handleToggleLineTool,
      children: /*#__PURE__*/jsx(DrawLineIcon, {
        size: 25
      })
    }), /*#__PURE__*/jsx(CSSRefTransition, {
      in: lineToolEnabled,
      timeout: 200,
      classNames: colorPickerWrapper,
      mountOnEnter: true,
      unmountOnExit: true,
      children: transitionRef => /*#__PURE__*/jsx(Tooltip, {
        placement: "bottom",
        body: "V\xE6lg stregfarve",
        ariaType: "label",
        disabled: isColorPickerOpen,
        containerRef: transitionRef,
        children: ref => /*#__PURE__*/jsx("div", {
          ref: ref,
          className: colorPickerWrapper,
          children: /*#__PURE__*/jsx(ColorPicker, {
            value: lineColor,
            onChange: handleChangeLineColor,
            onOpen: handleColorPickerOpen,
            onClose: handleColorPickerClose,
            className: colorPickerCls,
            placement: isMobile ? "top" : "left"
          })
        })
      })
    })]
  });
};

export { LineTool };
//# sourceMappingURL=tool.line.js.map
